import { login } from "../../services/Auth";
import { handleGetRequest } from "../../services/GetTemplate";
import { LOGIN_SUCCESS, LOGIN_ERROR } from "../slices/authenticationSlice";

export const loginAction = (authData) => async (dispatch) => {

  const res = await login(authData);
  if (res?.data?.login === true) {
    localStorage.setItem("token", res?.data?.token);
    localStorage.setItem("pwdUpdateFlag", res?.data?.tblUser?.pwdUpdateFlag);
    localStorage.setItem("nav", JSON.stringify(res?.data?.menu));
    localStorage.setItem("sessionTimeOut", res?.data?.sessionTimeOut);
    localStorage.setItem("userName", res?.data?.tblUser?.userName);
    localStorage.setItem("userEmail", res?.data?.tblUser?.email);
    localStorage.setItem(
      "roleName",
      res?.data?.tblUser?.tblUserRoles?.[0]?.tblRole?.roleName
    );
    localStorage.setItem("companyName", res?.data?.tblUser?.companyName);

   const companyName = localStorage.getItem("companyName");

    if (companyName) {
      const response = await handleGetRequest("zbizgateway/nonFin/getAllCompanies");
      const data = response?.data;
      const matchedCompId = await data?.find((i) => i?.companyName === companyName)?.companyId
      localStorage.setItem(
        "companyId",
        matchedCompId || null
      );
    }

    // Set permitted routes in LS
    let permsArr = []
    res?.data?.menu.map((menu) => {
      menu.items.map((route) => {
        permsArr.push(route.to)
      })
    })
    // console.log('permsArr', permsArr)
    const routesToAdd = ["/getmenu/:moduleId", "/getrolerights/:roleId", "/companydetails"]
    permsArr.push(routesToAdd)
    localStorage.setItem("permsArr", permsArr);

    dispatch(LOGIN_SUCCESS(res?.data));
    return res;
  } else {
    dispatch(LOGIN_ERROR("Error"));
    return res;
  }
};
